import { atom } from 'jotai';

export const rechargeWalletAtom = atom({
  isModalActive: false,
});
